export const ActionConsts = {
  Cart: {
    AddToCart: "Cart_AddToCart",
    MyCartProduct: "Cart_MyCartProduct",
    ClearCart: "Cart_ClearCart",
    setShippingCharge: "Cart_setShippingCharge",
    setEstimateDeliveyDate: "Cart_setEstimateDeliveyDate",
    setHeaderNotification: "Header_Notification",
    showLoader: "Show_Loader",
    hideLoader: "Hide_Loader",
    ShowCartLoader: "Show_CartLoader",
    HideCartLoader: "Hide_CartLoader",
  },
  User: {
    GetMyDetails: "User_GetMyDetails",
    setSelectedAddress: "User_setSelectedAddress",
    addNewAddress: "User_addNewAddress",
  },
};
